import { render, staticRenderFns } from "./InvoiceChargeModal.vue?vue&type=template&id=2f5bc95a&"
import script from "./InvoiceChargeModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceChargeModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceChargeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports